import {OperationPackage} from "@/services/PackageService";
import {formatterData} from "@/utils/formatterData";
import {
    SET_HIDDEN_APP_MESSAGE,
    SET_HIDDEN_FOR_APP,
    SET_ID_KID_LIST,
    SET_SHOW_APP_MESSAGE,
    SET_SHOW_FOR_APP,
    SET_MANAGER_TUITION_ID,
    SET_LIST_KIDS_REQUEST
} from "@/constant/actions";
import {Message} from 'element-ui';
import operationPackage from "@/services/PackageService/OperationPackage";

export const packageStore = {
    namespaced: true,
    state: {
        listHiddenForApp: [],
        listShowForApp: [],
        listKidsRequest: [],
        messageShowForApp: '',
        messageHiddenForApp: '',
        responseDataStudents: [],
        responseDataPackages: [],
        totalPage: 0,
        isLoading: false,
        idKidList: "",
        managerTuitionId: ""
    },
    getters: {
        GET_DATA: (state) => state.responseDataStudents,
        GET_TOTAL_PAGE: (state) => state.totalPage,
    },
    mutations: {
        SET_RESPONSE_DATA_LIST: (state, data) => {
            state.responseDataStudents = data;
        },

        SET_TOTAL_PAGE(state, totalPage) {
            state.totalPage = totalPage;
        },

        SET_IS_LOADING(state, boolean) {
            state.isLoading = boolean;
        },

        SET_RESPONSE_DATA_PACKAGES(state, data) {
            state.responseDataPackages = data;
        },

        DELETE_PACKAGES(state, id) {
            const packages = state.responseDataPackages;
            for (let i = 0; i <= packages.length; i++) {
                if (packages[i].id === id) {
                    packages.splice(i, 1);
                    break;
                }
            }
        },

        SET_LIST_HIDDEN_SHOW_FOR_APP(state, {idManagerTuitionList, status}) {
            const students = state.responseDataStudents;
            students.forEach(item => {
                const id = idManagerTuitionList.find(id => id === item.managerTuitionId);
                if (id) {
                    item.orderHidden = status;
                }
            });
        },

        SET_DATA_EXTEND_PACKAGE(state, {idManagerTuitionList, status}) {
            const students = state.responseDataStudents;
            students.forEach(item => {
                const managerTuitionId = idManagerTuitionList.find(id => item.managerTuitionId === id);
                if (managerTuitionId) {
                    item.checkStatus = status;
                }
            })
        },

        PAYMENT_OF_STUDENT(state, data) {
            if (state.responseDataStudents.length > 0) {
                for (let i = 0; i <= state.responseDataStudents.length; i++) {
                    if (state.responseDataStudents[i]?.id_kid === data?.idKids) {
                        state.responseDataStudents[i].collectedMoney += data?.collectedMoney;
                        state.responseDataStudents[i].cashMoney += data?.cash_money;
                        state.responseDataStudents[i].transferMoney += data?.transfer_money;
                        state.responseDataStudents[i].afterMoney = data?.afterMoney;
                        state.responseDataStudents[i].transactionEntry = data?.transactionEntry;
                        if (state.responseDataStudents[i].collectedMoney === 0) {
                            state.responseDataStudents[i].status = "Chưa đóng 100%";
                        } else if (state.responseDataStudents[i].collectedMoney > 0 && state.responseDataStudents[i].afterMoney < 0) {
                            state.responseDataStudents[i].status = "Chưa đóng đủ";
                        } else if (state.responseDataStudents[i].collectedMoney > 0 && state.responseDataStudents[i].afterMoney > 0) {
                            state.responseDataStudents[i].status = "Đóng thừa";
                        } else if (state.responseDataStudents[i].afterMoney === 0) {
                            state.responseDataStudents[i].status = "Đóng đủ 100%";
                        }
                        break;
                    }
                }
            }
        },

        UPDATE_PAYMENT_OF_STUDENT(state, data) {
            if (state.responseDataStudents.length >= 0) {
                for (let i = 0; i <= state.responseDataStudents.length; i++) {
                    if (state.responseDataStudents[i]?.id_kid === data?.idKid) {
                        state.responseDataStudents[i].collectedMoney = data?.collectedMoney;
                        state.responseDataStudents[i].cashMoney = data?.cash_money;
                        state.responseDataStudents[i].transferMoney = data?.transfer_money;
                        state.responseDataStudents[i].afterMoney = data?.afterMoney;
                        state.responseDataStudents[i].transactionEntry = data?.transactionEntry;
                        if (state.responseDataStudents[i].collectedMoney === 0) {
                            state.responseDataStudents[i].status = "Chưa đóng 100%";
                        } else if (state.responseDataStudents[i].collectedMoney > 0 && state.responseDataStudents[i].afterMoney < 0) {
                            state.responseDataStudents[i].status = "Chưa đóng đủ";
                        } else if (state.responseDataStudents[i].collectedMoney > 0 && state.responseDataStudents[i].afterMoney > 0) {
                            state.responseDataStudents[i].status = "Đóng thừa";
                        } else if (state.responseDataStudents[i].afterMoney === 0) {
                            state.responseDataStudents[i].status = "Đóng đủ 100%";
                        }
                        break;
                    }
                }
            }
        },
        UPDATE_PACKAGES(state, data) {
            const listPackage = state.responseDataPackages;
            for (let i = 0; i < listPackage.length; i++) {
                if (listPackage[i].id === data?.id) {
                    state.responseDataPackages[i].namePackage = data?.name;
                    state.responseDataPackages[i].descriptionPackage = data?.description;
                    break;
                }
            }
        },

        [SET_SHOW_FOR_APP](state, payload) {
            state.listShowForApp = payload
            state.messageShowForApp = ''
            state.listShowForApp.forEach((item, index) => {
                state.messageShowForApp = state.messageShowForApp.concat("<br>", `${index + 1} - ${item}`);
            })
        },
        [SET_SHOW_APP_MESSAGE](state, payload) {
            state.listShowForApp = [...state.listShowForApp, payload]
            state.listHiddenForApp = state.listHiddenForApp.filter(name => name !== payload)
            state.messageShowForApp = ''
            state.messageHiddenForApp = ''
            state.listShowForApp.forEach((item, index) => {
                state.messageShowForApp = state.messageShowForApp.concat("<br>", `${index + 1} - ${item}`);
            })
            state.listHiddenForApp.forEach((item, index) => {
                state.messageHiddenForApp = state.messageHiddenForApp.concat("<br>", `${index + 1} - ${item}`);
            })

        },
        [SET_HIDDEN_FOR_APP](state, payload) {
            state.listHiddenForApp = payload
            state.messageHiddenForApp = ''
            state.listHiddenForApp.forEach((item, index) => {
                state.messageHiddenForApp = state.messageHiddenForApp.concat("<br>", `${index + 1} - ${item}`);
            })
        },
        [SET_LIST_KIDS_REQUEST](state, payload) {
            state.listKidsRequest = payload
        },
        [SET_HIDDEN_APP_MESSAGE](state, payload) {
            state.listHiddenForApp = [...state.listHiddenForApp, payload]
            state.listShowForApp = state.listShowForApp.filter(name => name !== payload)
            state.messageHiddenForApp = ''
            state.messageShowForApp = ''
            state.listShowForApp.forEach((item, index) => {
                state.messageShowForApp = state.messageShowForApp.concat("<br>", `${index + 1} - ${item}`);
            })
            state.listHiddenForApp.forEach((item, index) => {
                state.messageHiddenForApp = state.messageHiddenForApp.concat("<br>", `${index + 1} - ${item}`);
            })
        },

        [SET_ID_KID_LIST](state, payload) {
            state.idKidList = payload.join(`,`);
        },

        [SET_MANAGER_TUITION_ID](state, payload) {
            state.managerTuitionId = payload.join(`,`);
        },

        SET_KT_STUDENT(state, {index, idManagerTuition, data}) {
            const students = state.responseDataStudents;

            if (students.length > 0) {
                for (let i = 0; i <= students.length; i++) {
                    if (idManagerTuition === students[i]?.managerTuitionId) {
                        let difference = students[i].listKt[index].money - data.moneyKt;

                        students[i].listKt[index].money = data.moneyKt;
                        students[i].sumMoney -= difference;
                        students[i].afterMoney += difference;
                    }
                }
            }
        }
    },
    actions: {
        fetchData: ({commit, dispatch}, {data, pagination}) => {
            dispatch("resetData");
            dispatch("setIsLoading", true);
            OperationPackage.filterPackageTuition(data, pagination)
                .then((res) => {
                    const data = res.data?.listFilter;
                    const totalPage = res.data?.totalPage;
                    const formatData = formatterData.transformData(data);
                    commit("SET_RESPONSE_DATA_LIST", formatData);
                    commit("SET_TOTAL_PAGE", totalPage);
                })
                .catch((err) => {
                    console.log(err);
                    Message({
                        message: "Lỗi dữ liệu!",
                        type: "error",
                        duration: 5000
                    });
                })
                .finally(() => {
                    dispatch("setIsLoading", false);
                })
        },

        fetchDataPackages({commit, dispatch}, boolean) {
            dispatch("setIsLoading", true);
            OperationPackage.getListPackageTuition(boolean)
                .then((res) => {
                    const data = res.data?.data;
                    commit("SET_RESPONSE_DATA_PACKAGES", data);
                })
                .catch((err) => {
                    console.log(err);
                    Message({
                        message: "Lỗi dữ liệu!",
                        type: "error",
                        duration: 5000
                    });
                })
                .finally(() => {
                    dispatch("setIsLoading", false);
                })
        },

        fetchHiddenShowForApp({commit, dispatch}, {idManagerTuitionList, status}) {
            dispatch("setIsLoading", true);
            const param = {
                idManagerTuitionList: idManagerTuitionList,
                idUser: "",
                userName: "",
                status: status,
            }

            operationPackage
                .checkShowForApp(param)
                .then((res) => {
                    Message({
                        message: res.data.message,
                        type: "success",
                    });
                    commit("SET_LIST_HIDDEN_SHOW_FOR_APP", {
                        idManagerTuitionList: idManagerTuitionList,
                        status: status
                    });
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    dispatch("setIsLoading", false);
                });
        },

        fetchExtendPackage({commit, dispatch}, {idManagerTuition, checkStatus}) {
            dispatch("setIsLoading", true);
            const param = {
                idManagerTuitionList: idManagerTuition,
                idSchool: "",
                isExtend: checkStatus
            }

            OperationPackage.subscribesPackage(param)
                .then((res) => {
                    commit("SET_DATA_EXTEND_PACKAGE", {idManagerTuitionList: idManagerTuition, status: checkStatus});
                    Message({
                        message: res.data.message,
                        type: "success",
                    })
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch("setIsLoading", false);
                })
        },

        resetData: ({commit}) => {
            commit("SET_RESPONSE_DATA_LIST", []);
        },

        setIsLoading: ({commit}, boolean) => {
            commit("SET_IS_LOADING", boolean);
        },

        deletePackages: ({commit}, id) => {
            commit("DELETE_PACKAGES", id);
        },

        updateDataBeforePayment: ({commit}, data) => {
            commit('PAYMENT_OF_STUDENT', data);
        },

        updateDataPayment: ({commit}, data) => {
            commit('UPDATE_PAYMENT_OF_STUDENT', data);
        },

        updatePackages({commit}, data) {
            commit("UPDATE_PACKAGES", data);
        },
    }
}